export default __webpack_public_path__ + "static/Plots0097-501fb30a3c894d1002ebc1c112376a8d.jpg";